const NOT_STARTED_MESSAGE = `Hi {studentName}! Just a gentle reminder about your application task related to {applicationName}. The deadline is coming up on {deadline}, so when you have a chance, please take a moment to review it. Let me know if you need any help along the way!`

const IN_PROGRESS_MESSAGE = `Hi {studentName}! Just a friendly reminder about your ongoing task for {applicationName}. With the {deadline} deadline coming up, I wanted to check in and make sure everything is moving smoothly. Feel free to reach out if you need any support!`

const fillTemplate = (template, values) =>
	Object.entries(values).reduce((text, [key, value]) => {
		const token = `{${key}}`
		return text.split(token).join(value)
	}, template)

export const getStudentFirstName = studentName => {
	const parts = String(studentName || '')
		.trim()
		.split(/\s+/)
		.filter(Boolean)
	return parts[0] || 'there'
}

export const formatAssignmentReminderDeadline = value => {
	if (!value) return ''
	const dt = new Date(value)
	if (Number.isNaN(dt.getTime())) return String(value).trim()
	return dt.toLocaleDateString('en-US', {
		month: 'short',
		day: 'numeric',
		year: 'numeric',
	})
}

export const buildAssignmentReminderMessage = ({
	status,
	studentName,
	applicationName,
	deadline,
}) => {
	const normalizedStatus = String(status || 'not_started')
		.trim()
		.toLowerCase()
	const template =
		normalizedStatus === 'in_progress' ? IN_PROGRESS_MESSAGE : NOT_STARTED_MESSAGE
	const deadlineLabel =
		formatAssignmentReminderDeadline(deadline) || 'the scheduled date'

	return fillTemplate(template, {
		studentName: getStudentFirstName(studentName),
		applicationName:
			String(applicationName || '').trim() || 'your application',
		deadline: deadlineLabel,
	})
}

export const ASSIGNMENT_REMINDER_COOLDOWN_TOOLTIP =
	'Reminder can only be sent once per hour'
